export default __webpack_public_path__ + "c3f093c40e41a4050d1632ba24631cfb.svg";